/* ============================================================================
 * product-recommendations.js
 *
 * Vanilla <product-recommendations> custom element. Replaces the jQuery
 * theme.ProductRecommendations module that lived in theme.js (~25 lines of
 * $.get + .html() injection).
 *
 * How it works:
 *
 *   First page render: Shopify hasn't computed recommendations yet
 *   (recommendations.performed = false in Liquid). The section file renders
 *   THIS custom element as a placeholder with a data-url pointing back at
 *   /recommendations/products.
 *
 *   On connectedCallback we fetch that URL. Shopify performs the
 *   recommendations and re-renders the same section — this time with
 *   recommendations.performed = true and the actual products list.
 *
 *   We extract .product-recommendations__inner from the response and inject
 *   it into ourselves, then fire a 'recommendations:loaded' event so any
 *   third-party scripts that were listening for the old jQuery event still
 *   get notified.
 *
 * Markup (rendered by sections/product-recommendations.liquid):
 *
 *   <product-recommendations
 *     data-url="/recommendations/products?section_id=product-recommendations
 *               &product_id=12345&limit=4">
 *   </product-recommendations>
 * ========================================================================= */

(function () {
  'use strict';

  if (customElements.get('product-recommendations')) return;

  class ProductRecommendations extends HTMLElement {
    connectedCallback() {
      // Avoid re-fetching if the element is moved around (e.g. barba page
      // swaps, theme editor re-renders).
      if (this._loaded) return;
      this._loaded = true;

      var url = this.getAttribute('data-url');
      if (!url) return;

      var self = this;
      fetch(url)
        .then(function (response) {
          if (!response.ok) {
            throw new Error('HTTP ' + response.status);
          }
          return response.text();
        })
        .then(function (text) {
          var doc = new DOMParser().parseFromString(text, 'text/html');
          var fresh = doc.querySelector('.product-recommendations__inner');
          if (fresh) {
            self.innerHTML = fresh.outerHTML;
            self.dispatchEvent(
              new CustomEvent('recommendations:loaded', { bubbles: true })
            );
            // Back-compat: legacy code subscribed to a document-level event.
            document.dispatchEvent(new CustomEvent('recommendations:loaded'));
          }
        })
        .catch(function (err) {
          // Recommendations failing should never break the PDP — log and
          // leave the placeholder empty.
          console.warn('[product-recommendations] fetch failed:', err);
        });
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);
})();
